export default __webpack_public_path__ + "static/media/meh.aed414f1.svg";